module.exports = __webpack_public_path__ + "static/media/meWinter.993c9802.JPG";